export default __webpack_public_path__ + "static/media/TASK - REACT (1).a24d6042.jpeg";